<div class="no-credit-warning-dialog-container">
  <div mat-dialog-title class="no-credit-warning-dialog__header">
    <img class="no-credit-warning-dialog__header-icon" src="/assets/icons/exclamation-icon-red.png">
    <span class="no-credit-warning-dialog__header-text">YOU HAVE REACHED YOUR CREDIT LIMIT</span>
    <span (click)="closeDialog()">
      <img class="themified-white-icon no-credit-warning-dialog__close-icon" src="/assets/icons/cross-icon.png">
    </span>
  </div>
  <div mat-dialog-content class="no-credit-warning-dialog__content">
    <p class="no-credit-warning-dialog__hint">You have insufficient credits for <span class="no-credit-warning-dialog__hint_search-engines">{{ noCreditSearchEngines }}</span>, please reach out to us at <a class="link link_underlined" href="mailto:clientservice@cynopsis.co" target="_blank">clientservice@cynopsis.co</a> to continue screening.</p>
    <p class="no-credit-warning-dialog__hint" *ngIf="!hideContinueButton">If you wish to skip the screening on {{ noCreditSearchEngines }}, click CONTINUE.</p>
  </div>
  <div mat-dialog-action class="no-credit-warning-dialog__button-container">
    <button class="btn btn_rounded no-credit-warning-dialog__button" mat-button ubi-round-button (click)="closeDialog()">
      Cancel
    </button>
    <button class="btn btn_rounded no-credit-warning-dialog__button" mat-button ubi-round-button (click)="continueAction()" *ngIf="!hideContinueButton">
      Continue
    </button>
  </div>
</div>
